import { Heart, Mail } from "lucide-react";
import NexaticeIcon from "../assets/nexatice-icon.svg";
import { useLanguage } from "../i18n";

export function Footer() {
  const { lang } = useLanguage();
  const prefix = `/${lang}`;
  const currentYear = new Date().getFullYear();

  return (
    <footer className="relative py-16 px-6 border-t border-white/5">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-12 mb-12">
          <div className="md:col-span-2">
            <a href="/" className="flex items-center gap-2 mb-4">
              <img src={NexaticeIcon} alt="Nexatice" className="w-6 h-6" />
              <span className="text-xl font-bold text-white">Nexatice</span>
            </a>
            <p className="text-sm text-zinc-500 max-w-sm mb-4">
              The powerful, modern database manager for developers who want to
              work smarter, not harder.
            </p>
            <a
              href="mailto:contact@nexatice.dev"
              className="inline-flex items-center gap-2 text-sm text-zinc-400 hover:text-emerald-400 transition-colors"
            >
              <Mail className="w-4 h-4" />
              contact@nexatice.dev
            </a>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">Product</h4>
            <ul className="space-y-3">
              <li>
                <a
                  href="#features"
                  className="text-sm text-zinc-400 hover:text-white transition-colors"
                >
                  Features
                </a>
              </li>
              <li>
                <a
                  href="#databases"
                  className="text-sm text-zinc-400 hover:text-white transition-colors"
                >
                  Databases
                </a>
              </li>
              <li>
                <a
                  href="#pricing"
                  className="text-sm text-zinc-400 hover:text-white transition-colors"
                >
                  Pricing
                </a>
              </li>
              <li>
                <a
                  href="#download"
                  className="text-sm text-zinc-400 hover:text-white transition-colors"
                >
                  Download
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">Resources</h4>
            <ul className="space-y-3">
              <li>
                <a
                  href="/docs"
                  className="text-sm text-zinc-400 hover:text-white transition-colors"
                >
                  Documentation
                </a>
              </li>
              <li>
                <a
                  href="/changelog"
                  className="text-sm text-zinc-400 hover:text-white transition-colors"
                >
                  Changelog
                </a>
              </li>
              <li>
                <a
                  href="/support"
                  className="text-sm text-zinc-400 hover:text-white transition-colors"
                >
                  Support
                </a>
              </li>
              <li>
                <a
                  href="/dashboard"
                  className="text-sm text-zinc-400 hover:text-white transition-colors"
                >
                  Account
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">Legal</h4>
            <ul className="space-y-3">
              <li>
                <a
                  href={`${prefix}/privacy`}
                  className="text-sm text-zinc-400 hover:text-white transition-colors"
                >
                  Privacy Policy
                </a>
              </li>
              <li>
                <a
                  href={`${prefix}/terms`}
                  className="text-sm text-zinc-400 hover:text-white transition-colors"
                >
                  Terms of Service
                </a>
              </li>
              <li>
                <a
                  href={`${prefix}/impressum`}
                  className="text-sm text-zinc-400 hover:text-white transition-colors"
                >
                  Impressum
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-zinc-500">
            © {currentYear} Nexatice. All rights reserved.
          </p>
          <p className="text-sm text-zinc-600 flex items-center gap-1">
            Made with <Heart className="w-3 h-3 text-red-500 animate-pulse" />{" "}
            by ZepioCs
          </p>
        </div>
      </div>
    </footer>
  );
}
